import "core-js/modules/es.array.index-of";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import VButton from '@comp/parts/VButton.vue';
export default {
  components: {
    VButton: VButton
  },
  props: {
    status: {
      type: String,
      required: true,
      validator: function validator(v) {
        return ['notFollowing', 'following', 'you'].indexOf(v) !== -1;
      }
    },
    loading: Boolean
  }
};